export default __webpack_public_path__ + "static/094-e676c8cf7a22f3e64fcc4fb76708878f.jpg";